/**
 * signup feature routes — owned by web-public.
 * Add child routes here (this file and everything under features/signup/ belong to the owner).
 * The pathless "signupFeature" route is registered once in src/app/router.tsx (frozen).
 */
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from '../../app/root-route';

export const signupFeature = createRoute({ getParentRoute: () => rootRoute, id: 'signup' });

export const signupRoute = createRoute({
  getParentRoute: () => signupFeature,
  path: '/r/$regToken',
  component: lazyRouteComponent(() => import('./pages/SignupPage'), 'SignupPage'),
});

export const signupRouteTree = signupFeature.addChildren([signupRoute]);
